<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title> 
                    <v-flex v-if="!Update_Details">
                        <v-flex v-if="Schedule_Type == 'Classroom'">Add Classroom Schedule</v-flex>
                        <v-flex v-else>Add Online Schedule</v-flex>
                    </v-flex>
                    <v-flex v-else>
                        <v-flex v-if="Schedule_Type == 'Classroom'">Update Classroom Schedule</v-flex>
                        <v-flex v-else>Update Online Schedule</v-flex>
                    </v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourse" :items="GetCourseDetailList" label="Select Course">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Course_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Course_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-menu ref="Register_Start_Date_Menu" v-model="Register_Start_Date_Menu" :close-on-content-click="false" transition="scale-transition" offset-y
                                    full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="Register_Start_Date" label="Register Start Date" persistent-hint
                                    prepend-icon="event" v-on="on" ></v-text-field>
                                </template>
                                <v-date-picker v-model="Register_Start_Date" no-title @input="Register_Start_Date_Menu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex>
                            <v-menu ref="Register_End_Date_Menu" v-model="Register_End_Date_Menu" :close-on-content-click="false" transition="scale-transition" offset-y
                                    full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="Register_End_Date" label="Register End Date" persistent-hint
                                    prepend-icon="event" v-on="on" ></v-text-field>
                                </template>
                                <v-date-picker v-model="Register_End_Date" no-title @input="Register_End_Date_Menu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Location" v-model="Schedule_Location"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Address" v-model="Schedule_Address"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-menu ref="Schedule_Start_Date_Menu" v-model="Schedule_Start_Date_Menu" :close-on-content-click="false" transition="scale-transition" offset-y
                                    full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="Schedule_Start_Date" label="Course Start Date" persistent-hint
                                    prepend-icon="event" v-on="on" ></v-text-field>
                                </template>
                                <v-date-picker v-model="Schedule_Start_Date" no-title @input="Schedule_Start_Date_Menu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex>
                            <v-menu ref="Schedule_End_Date_Menu" v-model="Schedule_End_Date_Menu" :close-on-content-click="false" transition="scale-transition" offset-y
                                    full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="Schedule_End_Date" label="Course End Date" persistent-hint
                                    prepend-icon="event" v-on="on" ></v-text-field>
                                </template>
                                <v-date-picker v-model="Schedule_End_Date" no-title @input="Schedule_End_Date_Menu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex>
                             <v-menu ref="Course_Time" v-model="Course_Time_Menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="Schedule_Time" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                <v-text-field v-model="Schedule_Time" label="Course Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                                </template>
                                <v-time-picker v-if="Course_Time_Menu" v-model="Schedule_Time" full-width @click:minute="$refs.Course_Time.save(Schedule_Time)"></v-time-picker>
                            </v-menu>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="Update_Details">
                        <v-switch label="Active Offer" v-model='Enable'></v-switch>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details" @click="AddSchedule">Add Schedule</v-btn>
                        <v-btn color="success" v-else @click="UpdateSchedule">Update Schedule</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Update_Details           : false,
            Schedule_Start_Date_Menu : false,
            Schedule_End_Date_Menu   : false,
            Register_Start_Date_Menu : false,
            Register_End_Date_Menu   : false,
            Schedule_Type            : "",
            SelectedCourse           : {},
            Schedule_Start_Date      : new Date().toISOString().substr(0, 10),
            Schedule_End_Date        : new Date().toISOString().substr(0, 10),
            Register_Start_Date      : new Date().toISOString().substr(0, 10),
            Register_End_Date        : new Date().toISOString().substr(0, 10),
            Schedule_Location        : "",
            Schedule_Address         : "",
            Schedule_Time            : null,
            Course_Time_Menu         : false,
            Enable                   : false,
            Schedule_Id              : ""

        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList.filter(x => x["Course_Types"].includes(this.Schedule_Type))
        }
    },
    methods:{
        SetScheduleType(Schedule_Type){
    
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.Schedule_Type = Schedule_Type
                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        CloseDialog(){

            this.$emit('close')
            this.ClearForm()
        },
        AddSchedule(){
            if (!this.SelectedCourse || !this.SelectedCourse['_id'] || !this.Schedule_Start_Date || !this.Schedule_End_Date || !this.Schedule_Time) {
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select a course and fill batch start date, end date, and time","Color":"red","Close": false });
                return
            }

            let Section = {}
            Section["Course_Id"]           = this.SelectedCourse["_id"]
            Section['Schedule_Type']       = this.Schedule_Type                       
            Section['Schedule_Start_Date'] = this.Schedule_Start_Date        
            Section['Schedule_End_Date']   = this.Schedule_End_Date
            Section['Schedule_Time']       = this.Schedule_Time      
            Section['Schedule_Location']   = this.Schedule_Location        
            Section['Schedule_Address']    = this.Schedule_Address         
            Section['Register_Start_Date'] = this.Register_Start_Date      
            Section['Register_End_Date']   = this.Register_End_Date        

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/addschedules`,Section)
                        .then(response =>{

                            this.$store.commit('SetIndividualSchedules',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Schedule","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Schedule","Color":"green","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedCourse       = {}
            this.Schedule_Type        = ''                      
            this.Schedule_Start_Date  = ''       
            this.Schedule_End_Date    = ''      
            this.Register_Start_Date  = ''   
            this.Register_End_Date    = ''     
            this.Schedule_Location    = '' 
            this.Schedule_Address     = ''
            this.Schedule_Time        = null
            this.Schedule_Id          = ''
            this.Enable               = false
            
        },
        SetUpdateStatus(Schedule){

            this.Update_Details = true
            this.Schedule_Id          = Schedule["_id"]
            this.SelectedCourse       = Schedule["CourseDetails"]
            this.Schedule_Type        = Schedule['Schedule_Type']          
            this.Schedule_Start_Date  = new Date(Schedule['Schedule_Start_Date']).toISOString().substr(0, 10)
            this.Schedule_End_Date    = new Date(Schedule['Schedule_End_Date']).toISOString().substr(0, 10)
            this.Schedule_Time        = Schedule['Schedule_Time']
            this.Schedule_Location    = Schedule['Schedule_Location']     
            this.Schedule_Address     = Schedule['Schedule_Address']      
            this.Register_Start_Date  = new Date(Schedule['Register_Start_Date']).toISOString().substr(0, 10)  
            this.Register_End_Date    = new Date(Schedule['Register_End_Date']).toISOString().substr(0, 10)   
            this.Enable               = Schedule["Enable"]
        },
        UpdateSchedule(){

            let Section = {}
            Section['Schedule_Id']         = this.Schedule_Id
            Section['update']              = {}
            Section['update']["Course_Id"]           = this.SelectedCourse["_id"]
            Section['update']['Schedule_Type']       = this.Schedule_Type                       
            Section['update']['Schedule_Start_Date'] = this.Schedule_Start_Date        
            Section['update']['Schedule_End_Date']   = this.Schedule_End_Date
            Section['update']['Schedule_Time']       = this.Schedule_Time      
            Section['update']['Schedule_Location']   = this.Schedule_Location        
            Section['update']['Schedule_Address']    = this.Schedule_Address         
            Section['update']['Register_Start_Date'] = this.Register_Start_Date      
            Section['update']['Register_End_Date']   = this.Register_End_Date
            Section['update']['Enable']              = this.Enable       

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/updateschedules`,Section)
                        .then(response =>{

                            this.$store.commit('UpdateIndividualSchedules',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Schedule","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Schedule","Color":"green","Close": false });
                        })
        },
        
    }
}
</script>
<style scoped>

</style>